module.exports = __webpack_public_path__ + "media/דג.950bcdb6.mp3";